module.exports = __webpack_public_path__ + "static/media/M1-18-Ariela-Baji-cod127.2a59b1c4.png";